import { Injectable } from '@angular/core';
import { ArticleVO } from '../model/vo/article.vo';
import { ArrayUtils } from '@shared/util/array-utils';
import { Log } from '@shared/debug/log';
import { ArticleManager } from './article.manager';
import { MiniTerminalBlocksProjectCreationService } from '@configuration/wizard/service/mini-terminal-blocks-project-creation.service';
import { ArticleDataService } from '../service/article-data.service';
import { ArticleAccessoryManager } from './article-accessory.manager';
import { firstValueFrom } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ProServeArticleManager {

  constructor(
    private articleManager: ArticleManager,
    private articleDataService: ArticleDataService,
    private articleAccessoryManager: ArticleAccessoryManager,
    private miniTerminalBlocksProjectCreationService: MiniTerminalBlocksProjectCreationService) {
  }

  private async getArticleByNumbersHandler(articles: ArticleVO[]): Promise<void> {
    this.articleManager.addArticlesAsLatestVersion(articles);
  }

  private async getLatestArticlesByNo(articleNumbers: string[]): Promise<ArticleVO[]> {
    if (ArrayUtils.isEmpty(articleNumbers)) {
      this.miniTerminalBlocksProjectCreationService.projectCreationFailureHandler();
      return [];
    }

    let articles: ArticleVO[];
    try {
      articles = await firstValueFrom(this.articleDataService.getLatestArticlesByNoObservable(articleNumbers));
    } catch (error) {
      Log.error('Could not load latest articles');
      this.miniTerminalBlocksProjectCreationService.projectCreationFailureHandler();
      return [];
    }
    this.articleAccessoryManager.getArticleByNumbers_successHandler(articles);
    await this.getArticleByNumbersHandler(articles);
    return articles;
  }

  public async retrieveArticlesByArticleNumbers(articleNumbers: string[]): Promise<ArticleVO[]> {
    const articleNumbersToRetrieve: string[] = [];
    for (let i: number = 0; i < articleNumbers.length; i++) {
      const articleNo: string = articleNumbers[i];
      if (!this.articleManager.existsArticleByArticleNumber(articleNo)) {
        if (articleNo !== 'EmptyZone' && articleNo !== 'BlockingZone') {
          articleNumbersToRetrieve.push(articleNo);
        }
      }
    }
    const existsArticle: ArticleVO[] = this.articleManager.getArticlesByArticleNumbers(articleNumbers);
    if (articleNumbersToRetrieve.length > 0) {
      return await this.getLatestArticlesByNo(articleNumbers);
    } else {
      await this.getArticleByNumbersHandler(existsArticle);
      this.articleAccessoryManager.getArticleByNumbers_successHandler(existsArticle);
      return existsArticle;
    }
  }
}
